/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youreventhasbeenupdatedsuccessfully5Inputs */

const en_youreventhasbeenupdatedsuccessfully5 = /** @type {(inputs: Youreventhasbeenupdatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your event has been updated successfully.`)
};

const de_youreventhasbeenupdatedsuccessfully5 = /** @type {(inputs: Youreventhasbeenupdatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Event wurde aktualisiert.`)
};

/**
* | output |
* | --- |
* | "Your event has been updated successfully." |
*
* @param {Youreventhasbeenupdatedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youreventhasbeenupdatedsuccessfully5 = /** @type {((inputs?: Youreventhasbeenupdatedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youreventhasbeenupdatedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youreventhasbeenupdatedsuccessfully5(inputs)
	return de_youreventhasbeenupdatedsuccessfully5(inputs)
});
export { youreventhasbeenupdatedsuccessfully5 as "yourEventHasBeenUpdatedSuccessfully" }